import http from '../httpConfig'
// 数据字典管理

// 字典列表查询
export const getList = (params) => {
    return new Promise((resolve, reject) => {
        http.post('/api/dictionary/list-dictionary/v1', params)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}
// 字典新增
export const getAdd = (params) => {
    return new Promise((resolve, reject) => {
        http.post('/api/dictionary/add-dictionary/v1', params)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}
// 字典修改
export const getChange = (params) => {
    return new Promise((resolve, reject) => {
        http.post('/api/dictionary/update-dictionary/v1', params)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}
// 字典删除
export const getDelete = (params) => {
    return new Promise((resolve, reject) => {
        http.post('/api/dictionary/delete-dictionary/v1', params)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

// 根据name获取字典数据  普通参照下拉 传参照名字就行
export const getDataByName = (dict_name) => {
    const params = {
        dict_name,
        '~table~': 'mrbase_sys_dict'
    }
    return new Promise((resolve, reject) => {
        http.post('/api/dictionary/list-dictionary-byname/v1', params)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}
// 字典详情
// 根据uuid获取详情
export const getDetail = (params) => {
    return new Promise((resolve, reject) => {
        http.post('/api/dictionary/find-dict/v1', params)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

// 根据name获取字典数据  普通参照下拉  传对象
export const get_dict_name = (params) => {
    params['~table~'] = 'mrbase_sys_dict'
    return new Promise((resolve, reject) => {
        http.post('/api/dictionary/list-dictionary-byname/v1', params)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}
